import type { ReactNode } from 'react'

import { F0Box, F0Heading, F0Text } from '@factorialco/f0-react'

interface Props {
  title: string
  description: string
  action?: ReactNode
}

const descriptionStyle = {
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '20px',
}

export const WizardStepHeader = ({ title, description, action }: Props) => {
  return (
    <F0Box display="flex" justifyContent="between" alignItems="start" width="full" gap="lg">
      <F0Box display="flex" flexDirection="column" gap="xs" width="full">
        <F0Heading as="h2" variant="heading-large" content={title} />
        <F0Text variant="description" content={description} style={descriptionStyle} />
      </F0Box>
      {action}
    </F0Box>
  )
}

export default WizardStepHeader
